export default "__VITE_ASSET__BiXiPtv8__"